import {Component} from '@angular/core';
import {NotificationService} from "../../services/notification/notification.service";

@Component({
  selector: 'app-suivi-demandes',
  templateUrl: './suivi-demandes.component.html',
  styleUrls: ['./suivi-demandes.component.scss']
})
export class SuiviDemandesComponent{

  constructor(protected notificationService: NotificationService) {
  }

  handleUpdateStatusEvent(_event: any) {
    const count: number = this.notificationService.countDemandNotificationSubject.getValue();
    if (_event && count > 0) {
      this.notificationService.countDemandNotificationSubject.next(count - 1);
    }
  }

  handleEmitTotalElementEvent(_event: any) {
    this.notificationService.countDemandNotificationSubject.next(_event? _event : 0);
  }
}
